export const IntegrationBase = ({
    registry_id = '',
    name = '',
    token_url = '',
    data_url = '',
    client_id = '',
    client_secret = '',
    mapping = [],
    active = true,
    use_for_register = false,
    token_ttl = 3600,
    needs_proxy = false,
}) => ({
    registry_id,
    name,
    token_url,
    data_url,
    client_id,
    client_secret,
    mapping,
    active,
    use_for_register,
    token_ttl,
    needs_proxy,
})

export const IntegrationBaseHydrate = ({
    id = '',
    registry_id = '',
    name = '',
    token_url = '',
    data_url = '',
    client_id = '',
    client_secret = '',
    mapping = [],
    active = true,
    use_for_register = false,
    token_ttl = 3600,
    needs_proxy = false,
    created_at = '',
    updated_at = '',
}) => ({
    id,
    registry_id,
    name,
    token_url,
    data_url,
    client_id,
    client_secret,
    mapping,
    active,
    use_for_register,
    token_ttl,
    needs_proxy,
    created_at,
    updated_at,
})